import React from 'react';
import { MenuItem, IconButton, Theme, makeStyles } from '@material-ui/core';
import BaseTypography from '../Text/BaseTypography';
import * as Colors from '../../theme/colors';
import { Action } from '../../constants';

const useStyles = makeStyles((theme: Theme) => ({
  delete: {
    color: Colors.red,
    '& svg': {
      color: Colors.red,
    },
  },
  icon: {
    color: Colors.BlackHeadings,
    padding: 0,
    marginRight: theme.spacing(2),
    '& svg': {
      fontSize: 14,
    },
  },
}));

interface ActionMenuProps {
  action: Action;
  onClick: (event: React.MouseEvent<HTMLLIElement>, action: Action) => void;
}

export const ActionMenuItem: React.FC<ActionMenuProps> = React.memo(
  ({ action, onClick }) => {
    const classes = useStyles();
    const addDeleteClass = !action.isDisabled && action.isDelete;
    return (
      <MenuItem
        data-testid={`action-${action.name}`}
        key={action.name}
        onClick={event => onClick(event, action)}
        disabled={action.isDisabled}
      >
        {action.icon && (
          <IconButton
            className={`${classes.icon} ${
              addDeleteClass ? classes.delete : ''
            }`}
            style={action.iconStyle}
          >
            {action.icon}
          </IconButton>
        )}
        <BaseTypography className={addDeleteClass ? classes.delete : ''} noWrap>
          {action.name}
        </BaseTypography>
      </MenuItem>
    );
  },
);
